<template>
    <div class="account">

        <!-- wallet -->
        <widget-wallet :total="pendingApprovalRewardTotal" v-if="!isFetchingContracts && !isFetchingTransactions"/>
        <template v-else>
            <v-card class="px-6 pt-4 pb-5 mb-4"
                    color="primary"
                    flat
                    tile>
                <v-row no-gutters class="align-center justify-space-between">
                    <v-col cols="7">
                        <v-skeleton-loader type="text"/>
                    </v-col>
                    <v-col cols="4">
                        <v-skeleton-loader type="chip" class="d-flex justify-end"/>
                    </v-col>
                </v-row>
                <v-divider class="my-2"></v-divider>
                <v-row no-gutters class="align-center justify-space-between">
                    <v-col cols="7">
                        <v-skeleton-loader type="text"/>
                    </v-col>
                    <v-col cols="4">
                        <v-skeleton-loader type="chip" class="d-flex justify-end"/>
                    </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>
                <v-row no-gutters class="align-center justify-space-between">
                    <v-col cols="7">
                        <v-skeleton-loader type="paragraph"/>
                    </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>
                <v-skeleton-loader type="button" class="d-flex justify-center"></v-skeleton-loader>
            </v-card>
        </template>
        <!-- /wallet -->

        <!-- challenges -->
        <div v-if="!isFetchingChallenges">
            <v-container v-if="challenges.length > 0" class="pa-0 mb-4">
                <div class="d-flex align-center py-2 px-5 accent">
                    <v-icon class="flex-grow-0 mr-3">mdi-medal-outline</v-icon>
                    <span class="mr-auto font-weight-bold">
                        {{ $vuetify.lang.t('$vuetify.challenges.active_challenges') }}
                    </span>
                </div>

                <v-expansion-panels tile flat accordion v-model="panel">
                    <v-expansion-panel v-for="(challenge, i) in challenges" :key="i">
                        <v-expansion-panel-header
                            expand-icon="mdi-menu-down"
                            class="py-1 pr-2">
                            <v-row class="pr-2 justify-space-between">
                                <v-col cols="3" sm="2">
                                    <p class="ma-0 font-weight-bold">
                                        {{ challenge.title }}
                                    </p>
                                </v-col>
                                <v-col>
                                    <div class="mb-2 body-2">
                                        {{ $vuetify.lang.t('$vuetify.challenges.duration') }}
                                        {{ challenge.scheduled_from_date | date }} - {{ challenge.scheduled_to_date | date }}
                                    </div>
                                    <div class="d-flex align-center justify-space-between">
                                        {{ $vuetify.lang.t('$vuetify.challenges.achieved_points') }}
                                        <span
                                            class="ml-4"
                                            :class="{
                                                'success--text': challenge.total_bonus_points >= 0,
                                                'error--text': challenge.total_bonus_points < 0,
                                            }">
                                            {{ challenge.total_bonus_points | number | balance }}
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-divider class="mb-4"></v-divider>
                            <v-row
                                v-for="item in challenge.rules"
                                :key="item.title"
                                class="justify-space-between pr-4">
                                <v-col cols="3" sm="2">
                                    <span class="subtitle-1">
                                        {{ item.title }}
                                    </span>
                                </v-col>
                                <v-col>
                                    <div class="mb-1 subtitle-1 font-weight-bold">
                                        {{ item.bonus_points | number | balance }}
                                        {{ $vuetify.lang.t('$vuetify.challenges.bonuspoints') }}
                                    </div>
                                    <div class="body-2">
                                        {{ item.description }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
        </div>

        <!--&lt;!&ndash; skeleton loading &ndash;&gt;-->
        <!--<template v-else>-->
            <!--<v-skeleton-loader-->
                <!--type="heading"-->
                <!--class="px-7 px-md-0 mb-2"-->
                <!--v-if="challenges.length > 0"-->
            <!--/>-->
            <!--<v-expansion-panels tile flat accordion class="mb-4">-->
                <!--<v-expansion-panel v-for="(item, i) in challenges" :key="i">-->
                    <!--<v-expansion-panel-header class="py-1" expand-icon=" ">-->
                        <!--<v-row class="pr-2 justify-space-between align-center">-->
                            <!--<v-col cols="2">-->
                                <!--<v-skeleton-loader type="sentences" />-->
                            <!--</v-col>-->
                            <!--<v-col cols="8">-->
                                <!--<v-skeleton-loader type="sentences" />-->
                            <!--</v-col>-->
                            <!--<v-col cols="2">-->
                                <!--<v-skeleton-loader type="avatar" class="d-flex justify-end" />-->
                            <!--</v-col>-->
                        <!--</v-row>-->
                    <!--</v-expansion-panel-header>-->
                <!--</v-expansion-panel>-->
            <!--</v-expansion-panels>-->
        <!--</template>-->
        <!--&lt;!&ndash; /skeleton loading &ndash;&gt;-->

        <!-- /challenges -->

        <!-- pending contracts -->
        <pending-contracts :contracts="contracts" v-if="!isFetchingContracts"></pending-contracts>

        <!-- skeleton loading -->
        <template v-else>
            <v-skeleton-loader type="heading" class="px-7 px-md-0 mb-2" v-if="contracts.length > 0"/>

            <v-expansion-panels tile flat accordion class="mb-4">
                <v-expansion-panel v-for="(item ,i) in contracts" :key="i">
                    <v-expansion-panel-header class="py-1" expand-icon=" ">
                        <v-row class="pr-2 justify-space-between align-center">
                            <v-col cols="2">
                                <v-skeleton-loader type="sentences"/>
                            </v-col>
                            <v-col cols="8">
                                <v-skeleton-loader type="sentences"/>
                            </v-col>
                            <v-col cols="2">
                                <v-skeleton-loader type="avatar" class="d-flex justify-end"/>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                </v-expansion-panel>
            </v-expansion-panels>
        </template>
        <!-- /skeleton loading -->
        <!-- /pending contracts -->

        <!-- transactions -->
        <transactions :transactions="transactions" v-if="!isFetchingTransactions"></transactions>

        <!-- skeleton loading -->
        <template v-else>
            <v-skeleton-loader type="heading" class="px-7 px-md-0 mb-2" v-if="transactions.length > 0"/>

            <v-expansion-panels tile flat accordion>
                <v-expansion-panel v-for="(item ,i) in transactions" :key="i">
                    <v-expansion-panel-header class="py-1" expand-icon=" ">
                        <v-row class="pr-2 justify-space-between align-center">
                            <v-col cols="2">
                                <v-skeleton-loader type="sentences"/>
                            </v-col>
                            <v-col cols="8">
                                <v-skeleton-loader type="sentences"/>
                            </v-col>
                            <v-col cols="2">
                                <v-skeleton-loader type="avatar" class="d-flex justify-end"/>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                </v-expansion-panel>
            </v-expansion-panels>
        </template>
        <!-- /skeleton loading -->
        <!-- /transactions -->

    </div>
</template>
<script>
    // components
    import Transactions from '../components/Widgets/Transactions';
    import PendingContracts from '../components/Widgets/PendingContracts';
    import WidgetWallet from '../components/Widgets/Wallet';
    // models
    import Challenge from '../models/Challenge';
    import Contract from '../models/Contract';
    import Transaction from '../models/Transaction';
    // utils
    import {
        LOADER_FETCH_PENDING_CONTRACTS,
        LOADER_FETCH_TRANSACTIONS,
    } from '../utils/constants';
    import { setPageTitle } from '../utils/helper';

    export default {
        name: 'account',
        components: {
            Transactions,
            PendingContracts,
            WidgetWallet,
        },
        data() {
            return {
                panel: null,
            }
        },
        computed: {
            challenges() {
                return Challenge.getAll();
            },
            pendingApprovalRewardTotal() {
                return Contract.getPendings().reduce((accumulator, contract) => accumulator + contract.contract_type.reward, 0);
            },
            transactions() {
                return Transaction.query().orderBy('created_at', 'desc').get();
            },
            contracts() {
                return Contract.getPendings();
            },
            isFetchingTransactions() {
                return this.$wait.is(LOADER_FETCH_TRANSACTIONS);
            },
            isFetchingContracts() {
                return this.$wait.is(LOADER_FETCH_PENDING_CONTRACTS);
            },
            isFetchingChallenges() {
                // TODO: get real values
                return false;
            },
        },
        mounted() {
            Transaction.fetch();
            Contract.fetchPendings();

            this.panel = this.$route.query.challengeId - 1;
        },
    }
</script>
